import { ViewRoom, ViewTable } from '@xeetr/types/models'
import { Trash2, GripVertical } from 'lucide-react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { DraggableAttributes } from '@dnd-kit/core'

interface Props {
  tableIndex: number
  table: ViewTable
  dragProps: DraggableAttributes | SyntheticListenerMap
}

const TableCardHeader = ({ tableIndex, dragProps }: Props) => {
  const { control } = useFormContext<ViewRoom>()

  const { remove: removeTableFromRoom } = useFieldArray({
    control,
    name: 'tables',
  })

  return (
    <div className="flex items-center justify-between">
      {/* 
        This is your dedicated drag handle. 
        Spreading dragProps here keeps the rest of the card clickable.
      */}
      <div
        {...dragProps}
        className="hover:bg-accent text-muted-foreground cursor-grab rounded p-1 transition-colors active:cursor-grabbing"
        title="Ziehen zum Neuanordnen"
      >
        <GripVertical className="h-4 w-4" />
      </div>

      <div className="flex items-center gap-2">
        <Button
          type="button" // Ensures it doesn't accidentally trigger form submissions
          variant="ghost"
          size="icon"
          className="text-destructive hover:text-destructive"
          onClick={() => removeTableFromRoom(tableIndex)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}

export default TableCardHeader
